export default __webpack_public_path__ + "static/DisplayHDR-1400-06c8dea7c7e03f4a57543f24ec545d05.png";